/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Islamic_Religion23Inputs */

const en__field__enum_teachingsubjects_subject_islamic_religion23 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Islamic_Religion23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Islamic Religion`)
};

const de__field__enum_teachingsubjects_subject_islamic_religion23 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Islamic_Religion23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Islamische Religion`)
};

/**
* | output |
* | --- |
* | "Islamic Religion" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Islamic_Religion23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_islamic_religion23 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Islamic_Religion23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Islamic_Religion23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_islamic_religion23(inputs)
	return de__field__enum_teachingsubjects_subject_islamic_religion23(inputs)
});
export { _field__enum_teachingsubjects_subject_islamic_religion23 as "_field__enum_teachingSubjects_SUBJECT_ISLAMIC_RELIGION" }